import { relations, sql } from 'drizzle-orm'
import {
  bigint,
  index,
  integer,
  jsonb,
  pgEnum,
  pgTable,
  text,
  uniqueIndex,
} from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getIdReference,
  getTimestampWithTimezone,
} from '../common/utils'
import { users } from './user'

export const activityTypeEnum = pgEnum('activity_type', [
  'note',
  'call',
  'email',
  'meeting',
  'stage_change',
  'task_status',
])

export const activities = pgTable(
  'activities',
  {
    ...getBaseFields(),
    entityType: text().notNull(),
    entityId: bigint({ mode: 'number' }).notNull(),
    type: activityTypeEnum().notNull(),
    subject: text().notNull(),
    content: text(),
    userId: getIdReference(() => users.id),
    metadata: jsonb(),
    // When the meeting is scheduled to happen — distinct from createdAt
    // (when it was booked). Populated for type='meeting'.
    scheduledAt: getTimestampWithTimezone(),
    // Meeting length in minutes; end time is derived (scheduledAt + this).
    durationMinutes: integer(),
  },
  (table) => getBaseIndexes('activities', table),
)

// External + internal people present at a meeting activity. User-level only —
// being a participant does NOT imply customer membership (that is a separate,
// optional customerMembers row created at booking time).
export const activityParticipants = pgTable(
  'activity_participants',
  {
    ...getBaseFields(),
    activityId: getIdReference(() => activities.id),
    userId: getIdReference(() => users.id),
  },
  (table) => [
    ...getBaseIndexes('activity_participants', table),
    index('activity_participants_activity_id_idx').on(table.activityId),
    index('activity_participants_user_id_idx').on(table.userId),
    uniqueIndex('activity_participants_activity_user_idx')
      .on(table.activityId, table.userId)
      .where(sql`${table.deletedAt} IS NULL`),
  ],
)

export const activitiesRelations = relations(activities, ({ one, many }) => ({
  user: one(users, {
    fields: [activities.userId],
    references: [users.id],
  }),
  participants: many(activityParticipants),
}))

export const activityParticipantsRelations = relations(
  activityParticipants,
  ({ one }) => ({
    activity: one(activities, {
      fields: [activityParticipants.activityId],
      references: [activities.id],
    }),
    user: one(users, {
      fields: [activityParticipants.userId],
      references: [users.id],
    }),
  }),
)
